module.exports = __webpack_public_path__ + "static/media/fiori.1b415af1.png";